import React, { useMemo } from 'react';
import * as Yup from 'yup';

// @mui
import { Box, Button, CircularProgress, Container, Paper, Stack } from '@mui/material';
// components
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';

import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useDevice } from '../hooks/useResponsive';
import { inspectionDocumentVerify } from '../server/api/inspectionBooking';
import { MetaHelmet } from '../layouts/Helmet/Helmet';
import { CenteredLabelTextField } from '../hooks';

export default function VerifyPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isMobile } = useDevice();

  const defaultValues = useMemo(() => ({}), []);
  const { loading } = useSelector((state) => ({
    loading: state.Inspection.loading,
  }));
  const FormSchema = Yup.object().shape({
    inspection_number: Yup.string().required('Inspection Number is required'),
    vehicle_number: Yup.string(),
  });
  const methods = useForm({
    resolver: yupResolver(FormSchema),
    defaultValues,
  });

  const onSubmit = async (value, e) => {
    e?.preventDefault();
    console.log(value);
    const credentials = {
      state: {
        inspection_number: value?.inspection_number,
        vehicle_number: value?.vehicle_number,
      },
      dispatch,
      navigate,
    };
    // console.log('credentials >>>>>', credentials);
    dispatch(inspectionDocumentVerify(credentials));
  };
  return (
    <>
      <MetaHelmet title={'Verify'} companyName={'Focus Motors'} />

      <Box className="bg-light ">
        <Container
          maxWidth="xl"
          sx={{
            padding: isMobile ? 'unset' : '0px 0px 500px 0px !important',
            position: 'relative',
            minHeight: !isMobile && '100vh',
            backgroundColor: '#f0f1f3',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: isMobile ? 150 : 500,
              backgroundImage: 'url(/assets/images/Inspection/VerifyBanner.webp)',
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          />
          <Container
            className=""
            maxWidth="md"
            sx={{
              mb: 4,
              position: 'absolute',
              top: isMobile ? 0 : '15%',
              left: '50%',
              transform: 'translateX(-50%)',
              borderRadius: isMobile ? 0 : '24px',
              backgroundColor: '#FFFFFF',
              p: 3,
              height: isMobile ? '76vh' : 'auto',
              alignItems: isMobile ? 'center' : 'unset',
              display: isMobile ? 'flex' : '',
            }}
          >
            <Paper
              elevation={3}
              sx={{
                borderRadius: 1,
                overflow: 'hidden',
                p: isMobile ? 2 : 0,
                boxShadow: 'unset',
                border: isMobile && '1px solid #33333333',
              }}
            >
              {/* Banner Image */}
              <Box
                sx={{
                  width: '100%',
                  height: isMobile ? 226 : 230,
                  backgroundImage: isMobile
                    ? 'url(/assets/images/Inspection/verifyMobile.webp)'
                    : 'url(/assets/images/Inspection/verifyWeb.webp)',
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  borderRadius: 1,
                }}
              />

              {/* Content */}
              <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                  <Container className="verify-page" sx={{ p: 4, textAlign: 'center' }} maxWidth="xs">
                    {/* <Typography variant="h5" fontWeight={500} pb={3} color="#121212">
                      View Inspection Report
                    </Typography> */}
                    <CenteredLabelTextField
                      name="inspection_number"
                      label="Inspection Number"
                      required
                      type="text"
                      margin="normal"
                      fullWidth
                      variant="outlined"
                    />
                    <CenteredLabelTextField
                      name="vehicle_number"
                      label="Vehicle Number"
                      required
                      type="text"
                      margin="normal"
                      fullWidth
                      variant="outlined"
                    />
                    <Stack gap={isMobile ? 1 : 2} mt={1}>
                      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                        {/* Close Button */}
                        {/* <Button
                          variant="outlined"
                          sx={{
                            mr: isMobile ? 1 : 2,
                            px: isMobile ? 2 : 4,
                            width: '100%',
                            borderRadius: '50px',
                            textTransform: 'none',
                            fontWeight: 600,

                            color: '#F16400',
                            border: '1px solid transparent',
                            background:
                              'linear-gradient(white, white) padding-box, linear-gradient(90deg, #FF9910 0%, #F16400 100%) border-box',
                            '&:hover': {
                              background:
                                'linear-gradient(white, white) padding-box, linear-gradient(90deg, #FF9910 0%, #F16400 100%) border-box',
                              // backgroundColor: '#fffaf5',
                              border: '1px solid #de8546ff',
                            },
                          }}
                        >
                          Close
                        </Button> */}

                        {/* View Document Button */}
                        <Button
                          variant="contained"
                          type="submit"
                          sx={{
                            px: isMobile ? 2 : 4,
                            borderRadius: '50px',
                            textTransform: 'none',
                            width: '100%',
                            fontWeight: 600,

                            background: 'linear-gradient(90deg, #FF9910 0%, #F16400 100%)',
                            color: 'white',
                            boxShadow: 'none',
                            '&:hover': {
                              background: 'linear-gradient(90deg, #ffad33 0%, #ff6d1a 100%)',
                              boxShadow: 'none',
                            },
                          }}
                        >
                          {loading ? <CircularProgress size={24} sx={{ color: '#342C2C' }} /> : 'View Document'}
                        </Button>
                      </Box>

                      {/* <Link
                        href="/inspection"
                        variant={isMobile ? 'caption' : 'body2'}
                        style={{ textDecoration: 'unset' }}
                      >
                        <Typography color="#2283F2 !important">Book Inspection Service</Typography>
                      </Link> */}
                    </Stack>
                  </Container>
                </form>
              </FormProvider>
            </Paper>
          </Container>
        </Container>
      </Box>
    </>
  );
}
